/**
 * Global auth configuration holder.
 * Projects call `initAuth(config)` at app startup to configure the auth system.
 */
let _config = null;
/**
 * Initialize the auth system with project-specific configuration.
 * Must be called once at app startup (e.g., in main.tsx) before rendering auth components.
 */
export function initAuth(config) {
    _config = config;
}
/**
 * Get the current auth configuration.
 * Throws if initAuth() hasn't been called.
 */
export function getAuthConfig() {
    if (!_config) {
        throw new Error('@ipsoftsrl/frontend-auth: initAuth() must be called before using auth components. ' +
            'Call initAuth({ login, cognito, apiBaseUrl }) in your app entry point.');
    }
    return _config;
}
//# sourceMappingURL=config.js.map